import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CbreAlertService } from '@cbre/alerts';
import { PropertySet } from '@miq/domain/property-sets';
import { PropertySetWidgetService } from '@records/records-search/records-details/visual-widget/property-sets-widget/property-set-widget.service';
import { L10nTranslationService } from 'angular-l10n';

@Component({
  selector: 'miq-property-set-confirm-dialog',
  templateUrl: './property-set-confirm-dialog.component.html',
  styleUrls: ['./property-set-confirm-dialog.component.scss'],
  standalone: false,
})
export class PropertySetConfirmDialogComponent {
  public propertySet: PropertySet;
  usageIds: number[] = [];
  // Security: use plain string instead of SafeHtml — messages come from i18n
  // translation strings and do not contain HTML; bypassing DomSanitizer is
  // unnecessary and widens the XSS attack surface.
  public messageOne: string;
  public messageTwo: string;

  constructor(
    public dialogRef: MatDialogRef<PropertySetConfirmDialogComponent>,
    private translationService: L10nTranslationService,
    private cbreAlertService: CbreAlertService,
    private propertySetWidgetService: PropertySetWidgetService,
    @Inject(MAT_DIALOG_DATA) public dialogData: { propertySet: PropertySet; usageIds: number[] }
  ) {
    this.propertySet = this.dialogData.propertySet;
    this.messageOne = this.translationService
      .translate(`propertySet.removeFromPropertySet`)
      .replace('{{propetSetName}}', this.propertySet.name);
    this.messageTwo = this.translationService.translate('propertySet.removeFromStatisticalPropertySet');
  }

  onClose(retry: boolean): void {
    this.dialogRef.close(retry);
  }

  removeFromPropertySet(): void {
    this.propertySetWidgetService
      .deletePropertiesToPropertySet(this.propertySet.id, this.dialogData.usageIds)
      .subscribe(() => {
        this.dialogRef.close(true);
        const removePropertySet = this.translationService
          .translate(`propertySet.removePropertySetfromProperty`)
          .replace('{{propetSetName}}', this.propertySet.name);
        this.cbreAlertService.showSuccessSnackBar(removePropertySet);
      });
  }
}
